import React, { useState, useEffect, useContext } from "react";
import { Stepper, Step } from "react-form-stepper";
import { useNavigate } from "react-router";

//components
import PageBanner from "../layouts/PageBanner";
import FirstStep from "../components/Fundraiser/FirstStep";
import SecondStep from "../components/Fundraiser/SecondStep";
import ThirdStep from "../components/Fundraiser/ThirdStep";
import FourthStep from "../components/Fundraiser/FourthStep";

//images
import bg from "../assets/images/banner/bnr3.jpg";
import bg2 from "../assets/images/background/bg4.jpg";
import { createProject } from "../apis/Projects";
import { AppContext } from "../context/AppContext";

const CreateProject = () => {
  const { user, handleLogOut } = useContext(AppContext);
  const navigate = useNavigate();

  const [goSteps, setGoSteps] = useState(0);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [projectImage, setProjectImage] = useState(null);
  const [projectData, setProjectData] = useState({
    title: "",
    description: "",
    category: "",
    start_date: "",
    end_date: "",
    goal_amount: "",
  });

  const newProject = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      let response = await createProject(
        projectData,
        projectImage,
        user.access
      );

      setProjectData({
        title: "",
        description: "",
        category: "",
        start_date: "",
        end_date: "",
        goal_amount: "",
      });
      setProjectImage(null);
      setGoSteps(2);
      setErrors({});
    } catch (error) {
      if (error.response?.status === 400) {
        setErrors(error.response?.data);
      } else if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        handleLogOut();
        navigate("/");
      } else {
        console.log(error);
      }
    }

    setLoading(false);
  };

  return (
    <>
      <div className="page-content bg-white">
        <PageBanner
          maintitle="Projects"
          pagetitle="Create Project"
          background={bg}
        />
        <section
          className="content-inner-1 section-pattren1 overlay-white-dark"
          style={{
            backgroundImage: "url(" + bg2 + ")",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="form-wrapper overflow-hidden">
                  <div className="form-wizard dz-form-step">
                    <Stepper
                      className="nav nav-wizard"
                      activeStep={goSteps}
                      label={false}
                    >
                      <Step
                        className="nav-link"
                        onClick={() => setGoSteps(0)}
                      />
                      <Step
                        className="nav-link"
                        onClick={() => setGoSteps(1)}
                      />
                    </Stepper>
                    {Object.keys(errors).length > 0 && (
                      <div style={{ color: "red", marginBottom: 20 }}>
                        <ul>
                          {Object.entries(errors).map(([field, messages]) =>
                            messages.map((message, index) => (
                              <li
                                key={`${field}-${index}`}
                                style={{ fontSize: 14 }}
                              >
                                <strong>{field.replace("_", " ")}:</strong>{" "}
                                {message}
                              </li>
                            ))
                          )}
                        </ul>
                      </div>
                    )}
                    {goSteps === 0 && (
                      <>
                        <FirstStep
                          projectImage={projectImage}
                          setProjectImage={setProjectImage}
                          projectData={projectData}
                          setProjectData={setProjectData}
                        />
                        <br />
                        <div className="text-end toolbar toolbar-bottom pt-2">
                          <button
                            className="btn sw-btn-next sw-btn ms-1npm"
                            onClick={() => setGoSteps(1)}
                            style={{ width: "100%" }}
                          >
                            Continue
                          </button>
                        </div>
                      </>
                    )}
                    {goSteps === 1 && (
                      <>
                        <SecondStep
                          projectData={projectData}
                          setProjectData={setProjectData}
                        />
                        <div
                          className="text-end toolbar toolbar-bottom pt-2"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <button
                            className="btn sw-btn-prev sw-btn"
                            onClick={() => setGoSteps(0)}
                            style={{
                              width: "29%",
                              backgroundColor: "#888",
                              border: "1px solid #888",
                            }}
                          >
                            Back
                          </button>
                          <button
                            disabled={loading}
                            className="btn sw-btn-next sw-btn"
                            onClick={newProject}
                            style={{ width: "69%" }}
                          >
                            {loading ? "Loading ..." : "Submit"}
                          </button>
                        </div>
                      </>
                    )}
                    {goSteps === 2 && (
                      <>
                        <ThirdStep />
                        <div className="text-end toolbar toolbar-bottom pt-4">
                          <button
                            className="btn sw-btn-next sw-btn"
                            onClick={() => navigate("/project")}
                            style={{ width: "100%" }}
                          >
                            Back to Projects
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CreateProject;
